/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SyncTrackFeatureItemDto interface.
 */
export function instanceOfSyncTrackFeatureItemDto(value) {
    if (!('contentHash' in value) || value['contentHash'] === undefined)
        return false;
    return true;
}
export function SyncTrackFeatureItemDtoFromJSON(json) {
    return SyncTrackFeatureItemDtoFromJSONTyped(json, false);
}
export function SyncTrackFeatureItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contentHash': json['contentHash'],
        'tempo': json['tempo'] == null ? undefined : json['tempo'],
        'keyCamelot': json['keyCamelot'] == null ? undefined : json['keyCamelot'],
        'energy': json['energy'] == null ? undefined : json['energy'],
        'danceability': json['danceability'] == null ? undefined : json['danceability'],
        'valence': json['valence'] == null ? undefined : json['valence'],
        'acousticness': json['acousticness'] == null ? undefined : json['acousticness'],
        'instrumentalness': json['instrumentalness'] == null ? undefined : json['instrumentalness'],
        'liveness': json['liveness'] == null ? undefined : json['liveness'],
        'speechiness': json['speechiness'] == null ? undefined : json['speechiness'],
        'loudness': json['loudness'] == null ? undefined : json['loudness'],
        'crateScore': json['crateScore'] == null ? undefined : json['crateScore'],
        'workerVersion': json['workerVersion'] == null ? undefined : json['workerVersion'],
        'analyzedAt': json['analyzedAt'] == null ? undefined : json['analyzedAt'],
    };
}
export function SyncTrackFeatureItemDtoToJSON(json) {
    return SyncTrackFeatureItemDtoToJSONTyped(json, false);
}
export function SyncTrackFeatureItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'contentHash': value['contentHash'],
        'tempo': value['tempo'],
        'keyCamelot': value['keyCamelot'],
        'energy': value['energy'],
        'danceability': value['danceability'],
        'valence': value['valence'],
        'acousticness': value['acousticness'],
        'instrumentalness': value['instrumentalness'],
        'liveness': value['liveness'],
        'speechiness': value['speechiness'],
        'loudness': value['loudness'],
        'crateScore': value['crateScore'],
        'workerVersion': value['workerVersion'],
        'analyzedAt': value['analyzedAt'],
    };
}
